import { Link } from '@tanstack/react-router';
import { AnimatePresence, motion } from 'motion/react';
import { Sparkles, X } from 'lucide-react';
import type { WrapBannerState } from '@/features/wrap/hooks/useWrapBanner';
import { Button } from '@/shared/components/ui/button';

type WrapBannerProps = Pick<WrapBannerState, 'shouldShow' | 'dismiss' | 'year'>;

/** Nudge while the wrap is enabled, until the story is opened or dismissed. */
export function WrapBanner({ shouldShow, dismiss, year }: WrapBannerProps) {
  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className="overflow-hidden"
        >
          <div className="bg-wrap-night text-wrap-cream">
            <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-4 py-3">
              <Sparkles aria-hidden className="size-4 shrink-0 text-wrap-amber" />
              <p className="min-w-0 truncate text-sm">Your {year} in RobinHoot is ready.</p>
              <Button
                asChild
                size="sm"
                className="h-7 shrink-0 bg-wrap-amber px-3 text-xs text-wrap-ink hover:bg-wrap-amber/90"
              >
                <Link to="/wrap" onClick={dismiss}>
                  Take a look
                </Link>
              </Button>
              <button
                type="button"
                onClick={dismiss}
                className="shrink-0 rounded-md p-1 text-wrap-cream/70 transition-colors hover:bg-wrap-cream/10 hover:text-wrap-cream"
                aria-label="Dismiss the year in review banner"
                title="Dismiss"
              >
                <X className="size-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
